import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Li Wei',
  role: 'Regular Customer',
  content: 'Shiok8是我用过最靠谱的按摩推荐平台。技师手法非常专业，服务态度也很好。每次感到疲惫时，这里都是我的首选。',
  rating: 5
}, {
  name: 'Sarah Tan',
  role: 'Office Worker',
  content: 'Very impressed with the verification process. I feel safe and relaxed knowing the therapists are certified. The booking was seamless!',
  rating: 5
}, {
  name: 'Raj Kumar',
  role: 'Fitness Enthusiast',
  content: 'Great for sports recovery massage. Found an amazing therapist who really understands muscle recovery. Highly recommended!',
  rating: 5
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="py-24 bg-[#F5EDE0]" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="text-center mb-16" data-id="element-170">
          <span className="text-[#C9A96E] font-medium tracking-widest uppercase text-sm" data-id="element-171">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A3D] mt-2" data-id="element-172">
            用户真实反馈
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-173">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 relative" data-id="element-174">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#F5EDE0] fill-current" data-id="element-175" />

              <div className="flex space-x-1 mb-6" data-id="element-176">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 text-[#C9A96E] fill-current" data-id="element-177" />)}
              </div>

              <p className="text-[#4A4A4A] italic mb-8 leading-relaxed" data-id="element-178">
                "{testimonial.content}"
              </p>

              <div className="flex items-center" data-id="element-179">
                <div className="w-10 h-10 rounded-full bg-[#2D5A3D]/10 flex items-center justify-center text-[#2D5A3D] font-bold font-serif" data-id="element-180">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="ml-4" data-id="element-181">
                  <h4 className="font-bold text-[#1A1A1A]" data-id="element-182">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-[#999] uppercase tracking-wide" data-id="element-183">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}